import { render } from "./IncomeSelect.vue?vue&type=template&id=025ebe17&scoped=true"
import script from "./IncomeSelect.vue?vue&type=script&lang=js"
export * from "./IncomeSelect.vue?vue&type=script&lang=js"

import "./IncomeSelect.vue?vue&type=style&index=0&id=025ebe17&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025ebe17"]])

export default __exports__